module.exports = __webpack_public_path__ + "static/media/Wendell.8bf09620.png";